module.exports = __webpack_public_path__ + "static/media/xlm.33d74ef0.svg";